export default {
      id: "bulle_kiosque-usage",
      viewBox: "0 0 230 220",
      url: "../dist/images/" + "sprite.svg#bulle_kiosque-usage",
      toString: function () {
        return this.url;
      }
    }